<div class="sgt-taxa-crescimento" *ngIf="taxaCrescimento != null && taxaCrescimento !== undefined"
    [class.down]="taxaCrescimento < 0"
    [class.equals]="taxaCrescimento == 0"
    [class.up]="taxaCrescimento > 0">
    <span class="sgt-taxa-crescimento-icon">
        <ng-template [ngIf]="taxaCrescimento < 0">
            <i class="fas fa-long-arrow-alt-down"></i>
        </ng-template>
        <ng-template [ngIf]="taxaCrescimento > 0">
            <i class="fas fa-long-arrow-alt-up"></i>
        </ng-template>                        
    </span>
    <span class="sgt-taxa-crescimento-value">
        {{taxaCrescimento | decimalFormat: 1:minFractionDigits:maxFractionDigits}}%
    </span>        
</div>